import notificationService from "../services/notification.service";
import ACTION_TYPE from "./type.action";

export const getNotifications = userID => async dispatch => {
  let notifications = await notificationService.read(userID);
  dispatch({
    type: ACTION_TYPE.GETALL_NOTIFICATION,
    payload: notifications
  });
};

export const deleteNotifications = userID => async dispatch => {
  await notificationService.deleteAll(userID);
  dispatch({
    type: ACTION_TYPE.DELETEALL_NOTIFICATION,
  });
};